import React from "react";
import Reveal from "./Reveal";

const About = () => {
  return (
    <div id="about" className="w-full">
      <div className="flex flex-col justify-center w-full h-full max-w-screen-lg p-4 pt[80px] mx-auto ">
        <Reveal slidePermission={false}>
          <div>
            <div className="fadein">
              {/* <Reveal slidePermission={true}> */}
              <div className="inline-flex items-center gap-2 sm:p-2 p-1 text-4xl font-bold text-white">
                About Me
                <svg
                  width="60"
                  height="50"
                  viewBox="0 0 75 62"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className=" translate-y-7"
                >
                  <path
                    d="M1 1C6.24431 1.21626 11.5365 2.05428 16.6516 3.13955C28.7596 5.70848 41.2898 9.45859 51.3287 17.0631C61.1747 24.5214 66.3737 34.4703 69.1034 46.2597C70.3557 51.6681 70.3959 56.1136 70.6176 61.434"
                    stroke="#D4D4D4"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeDasharray="4 4"
                  />
                  <path
                    d="M63 57.185C65.135 58.2982 67.2076 59.4555 69.2541 60.7235C70.1813 61.2979 70.997 62.1916 71.624 60.9045C72.5057 59.0948 73.0026 57.3294 74.5536 56"
                    stroke="#D4D4D4"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              {/* </Reveal> */}
            </div>

            {/* <Reveal slidePermission={true}> */}
            <div className="px-0 mt-6 sm:!text-lg text-[15px] text-[#CCD6F6] md:text-xl fadein md:px-4 !font-normal">
              Hello, my name is Md Firdosh from Dhanbad, Jharkhand, I completed
              my BCA degree from Indira Gandhi Open University in 2024, and
              currently working as a Jr. software developer at Teckat Service
              Private Limited.
              <br />
              <br />I have 2 years of experience building responsive,
              accessible, and user-friendly web applications using React.js and
              Next.js, along with improving performance and integrating RESTful
              APIs with the frontend for real-time data handling, ensuring fast,
              reliable, and efficient communication between the client and
              server.
              <br /> <br /> I’m continuously enhancing my skills to become a
              proficient MERN Stack Developer, with a strong focus on clean
              code, performance optimization, and scalable architecture...
              {/* My expertise includes
            integrating RESTful APIs for efficient data handling and real-time
            functionality. I am aspiring to become a MERN stack developer */}
            </div>
            {/* </Reveal> */}
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default About;
